module.exports = __webpack_public_path__ + "static/pomoc-drogowa-holowanie-0686465b2bad25a71efcdb7665fb930c.jpeg";